import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { getOrganizations, confirmCourier, setAuthToken } from '../api';
import { Header, Loader } from '../components';
import config from '../config';

const LoginScreen = ({ navigate }) => {
  const { login } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [orgId, setOrgId] = useState('');
  const [code, setCode] = useState('');
  const [pincode, setPincode] = useState('');
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgsLoading, setOrgsLoading] = useState(true);

  useEffect(() => {
    getOrganizations()
      .then((data) => {
        const sorted = (data.organizations || []).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
        setOrgs(sorted);
      })
      .catch(() => {})
      .finally(() => setOrgsLoading(false));
  }, []);

  const handleSubmit = async () => {
    if (!orgId || !code) return;
    setLoading(true);
    setError(false);
    try {
      const result = await confirmCourier(code, pincode, orgId);
      if (result.token) {
        setAuthToken(result.token);
        login(result.token, orgId);
        navigate('list');
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
      setCode('');
    }
  };

  return (
    <>
      <Header title="Алло! Пицца" />
      <div className="screen">
        <div className="login-screen">
          <div className="login-logo">
            Алло!<span> Пицца</span>
          </div>
          <div className="login-subtitle">Вход для курьера</div>

          {orgsLoading ? (
            <Loader />
          ) : (
            <>
              <div className="select-wrapper" style={{ width: '100%' }}>
                <select
                  value={orgId}
                  onChange={(e) => setOrgId(e.target.value)}
                >
                  <option value="">Выберите точку</option>
                  {orgs.map((o) => (
                    <option key={o.id} value={o.id}>{o.name}</option>
                  ))}
                </select>
              </div>

              <input
                className={`input-field${isError ? ' error' : ''}`}
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Код курьера"
                inputMode="numeric"
                pattern="[0-9]*"
                style={{ width: '100%' }}
              />

              <input
                className={`input-field${isError ? ' error' : ''}`}
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                placeholder="Пин-код"
                inputMode="numeric"
                pattern="[0-9]*"
                style={{ width: '100%' }}
              />

              {isError && (
                <div className="error-text">Неверный код или точка. Попробуйте ещё раз.</div>
              )}

              <button
                className="btn"
                disabled={!orgId || !code || !pincode || loading}
                onClick={handleSubmit}
                style={{ marginTop: 8 }}
              >
                {loading ? 'Вход...' : 'К списку доставок'}
              </button>
            </>
          )}
        </div>
        <div className="version-tag">v{config.VERSION}</div>
      </div>
    </>
  );
};

export default LoginScreen;
